import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vlvbxboopvdqnwwxccgm.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsdmJ4Ym9vcHZkcW53d3hjY2dtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzExNjU4OTksImV4cCI6MjA4Njc0MTg5OX0.XRl2i9sL5yqbWIfVOJr-vRkP7X_pjSMZ2EnL6exkrXo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
